module.exports = __webpack_public_path__ + "img/ai-pic4.889747a4.png";